import { OrderEventStatus } from "@boma/supplier-portal/shared/entities";

export class TransferListItem {
  public id: string;
  public createdAt: Date;
  public supplyingLocationName: string;
  public receivingLocationName: string;
  public createdByName: string;
  public referenceNumber: string;
  public status: OrderEventStatus;
  public quantity: number;
  public total: number;
  public originIsSupplier: boolean;

  constructor(init: Partial<TransferListItem>) {
    Object.assign(this, init);
  }
}
